import { render } from "./ProductPriceList.vue?vue&type=template&id=17e91ee8&scoped=true"
import script from "./ProductPriceList.vue?vue&type=script&lang=js"
export * from "./ProductPriceList.vue?vue&type=script&lang=js"

import "./ProductPriceList.vue?vue&type=style&index=0&id=17e91ee8&scoped=true&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e91ee8"]])

export default __exports__